.canvas {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.drawer {
  max-width: 1280px;
  margin: auto;
}
